var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93359 8.4527C3.93359 4.70486 6.91836 1.66663 10.6003 1.66663C14.2822 1.66663 17.2669 4.70486 17.2669 8.4527C17.2669 12.1712 15.1392 16.5103 11.8194 18.062C11.0455 18.4237 10.155 18.4237 9.38115 18.062C6.06136 16.5103 3.93359 12.1712 3.93359 8.4527Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6001,
    cy: 8.33337,
    r: 2.5,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locations_icon.fcdd59e5c2ec941c1263420b42e24a66.svg";
export { ForwardRef as ReactComponent };